import React, { useState } from "react";

const ProductModalOnStockPage = ({ isOpen, onClose, addProduct, selectedCategoryId }) => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [availableStock, setAvailableStock] = useState("");
  const [unitType, setUnitType] = useState("MP"); // Alapértelmezett érték

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || price <= 0 || availableStock < 0) {
      alert("Toate câmpurile trebuie completate corect!");
      return;
    }

    const newProduct = {
      name,
      price: parseFloat(price),
      availableStock: parseInt(availableStock),
      unitType,
      categoryId: selectedCategoryId,
    };

    await addProduct(newProduct);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg w-96 relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-red-500 text-4xl">
          &times;
        </button>
        <h2 className="text-xl font-semibold mb-4">Adăugare Produs Nou</h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="text"
            placeholder="Nume produs"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="number"
            placeholder="Preț (RON)"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="number"
            placeholder="Stoc disponibil"
            value={availableStock}
            onChange={(e) => setAvailableStock(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
          <select
            value={unitType}
            onChange={(e) => setUnitType(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="MP">MP</option>
            <option value="BUC">BUC</option>
          </select>
          <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded">
            Adaugă Produs
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProductModalOnStockPage;
